import React from 'react'
import { Route, Redirect } from 'react-router-dom'


//const regexPublicRepo= new RegExp('^[a-zA-Z0-9_]+/[a-zA-Z0-9-]+-[0-9]+$')

const RedirectAuthenticated = ({
	path,
	location,
	isAuthenticated,
	willAuthenticate,
	component: Component,
}: Props) =>
{
	if (isAuthenticated ){
		const hash=window.location.hash.replace(/#/g, '')
		//const redirectToRepo=regexPublicRepo.test(hash)
		if(hash){
			return( 
				<Redirect to={{ pathname: `/${hash}` }} /> 
			)
		}
		else return( 
			<Redirect to={{ pathname: '/library' }} /> 
		)
	} 

	else if(!isAuthenticated && !willAuthenticate){
		return(	
			<Route
		 		exact
		 		path={path}
		 		render={(props) => {
		 			 if (typeof window.ga === 'function') {
						    window.ga('set', 'page',  location.pathname + location.search)
						    window.ga('send', 'pageview')
  						}
		 			return <Component {...props} /> }}
			/>
			
		)
 
	}
	else return null

}

export default RedirectAuthenticated
   